import { IApiResponse } from '../interfaces/IApiResponse';
import urls from './urls';
import axios from 'axios';

interface PhoneParams {
  phone: string;
}

interface VerifyPhoneParams {
  code: string;
}

interface EmailParams {
  email: string;
}

interface PasswordParams {
  password: string;
  currentPassword: string;
}

interface UsernameParams {
  username: string;
}

interface PauseAccountParams {
  reason: string;
}

interface DeleteAccountParams {
  reason: string;
}

class AccountSettingApi {
  static getUserPhone(): Promise<IApiResponse> {
    return axios
      .get<any, IApiResponse>(urls.GET_USER_PHONE, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } })
      .then(res => res);
  }

  static postUpdateUserPhone(params: any): Promise<IApiResponse> {
    return axios.post<any, IApiResponse>(urls.UPDATE_USER_PHONE, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postVerifyUserPhone(params: VerifyPhoneParams): Promise<IApiResponse> {
    return axios.post<any, IApiResponse>(urls.VERIFY_USER_PHONE, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postVerifyResendUserPhone(params: PhoneParams): Promise<IApiResponse> {
    return axios.post<any, IApiResponse>(urls.VERIFY_RESEND_USER_PHONE, params, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static postValidatePhoneNumber(params: PhoneParams): Promise<IApiResponse> {
    return axios.post<any, IApiResponse>(urls.VALIDATE_PHONE_NUMBER, params, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static patchEmailAddress(params: EmailParams): Promise<IApiResponse> {
    return axios.patch<any, IApiResponse>(urls.UPDATE_USER_EMAIL, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchPassword(params: PasswordParams): Promise<IApiResponse> {
    return axios.patch<any, IApiResponse>(urls.UPDATE_USER_PASSWORD, params, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static patchUserName(params: UsernameParams): Promise<IApiResponse> {
    return axios.patch<any, IApiResponse>(urls.UPDATE_USER_USERNAME, params, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static deletePhoneNumber(): Promise<IApiResponse> {
    return axios.delete<any, IApiResponse>(urls.UPDATE_USER_PHONE, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postPauseAccount(params?: PauseAccountParams): Promise<IApiResponse> {
    return axios.post<any, IApiResponse>(urls.POST_PAUSE_ACCOUNT, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postUnPauseAccount(): Promise<IApiResponse> {
    return axios.post<any, IApiResponse>(urls.POST_UNPAUSE_ACCOUNT, {}, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static deleteAccount(params: DeleteAccountParams): Promise<IApiResponse> {
    return axios.delete<any, IApiResponse>(urls.DELETE_ACCOUNT, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
      data: params,
    });
  }

  static connectAccountApple(params: { AccessToken: string; AccessTokenSecret: string } | null): Promise<IApiResponse> {
    return axios.patch<any, IApiResponse>(urls.CONNECT_DELETE_ACCOUNT_APPLE, params, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static deleteAccountApple(): Promise<IApiResponse> {
    return axios.delete<any, IApiResponse>(urls.CONNECT_DELETE_ACCOUNT_APPLE, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static connectAccountFacebook(params: { UserID: string; AccessToken: string } | null): Promise<IApiResponse> {
    return axios.patch<any, IApiResponse>(urls.CONNECT_DELETE_ACCOUNT_FACEBOOK, params, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static deleteAccountFacebook(): Promise<IApiResponse> {
    return axios.delete<any, IApiResponse>(urls.CONNECT_DELETE_ACCOUNT_FACEBOOK, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static connectAccountGoogle(params: { AccessToken: string } | null): Promise<IApiResponse> {
    return axios.patch<any, IApiResponse>(urls.CONNECT_DELETE_ACCOUNT_GOOGLE, params, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static deleteAccountGoogle(): Promise<IApiResponse> {
    return axios.delete<any, IApiResponse>(urls.CONNECT_DELETE_ACCOUNT_GOOGLE, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static createPassword(params: PasswordParams): Promise<IApiResponse> {
    return axios.post<any, IApiResponse>(urls.CREATE_USER_PASSWORD, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default AccountSettingApi;
